import actions from './actions';

const initialState = {
    // Catálogo
    insumos:    [],
    mercancias: [],
    currentInsumo:  null,
    currentProceso: null,

    // Registro legado
    inventario:         [],
    initialInventario:  false,
    loadingInventario:  false,

    // Movimientos (nuevo sistema)
    movimientos:           [],
    paginacionMovimientos: { totalDocs: 0, totalPages: 0, page: 1, pageSize: 50 },
    loadingMovimientos:    false,

    // Stock actual
    stock:                 [],
    valorTotalInventario:  0,
    loadingStock:          false,

    // Alertas
    alertas:         [],
    loadingAlertas:  false,

    // Rotación
    rotacion:        [],
    loadingRotacion: false,
};

export default function inventarioReducer(state = initialState, action) {
    switch (action.type) {

        // ── Catálogo ──────────────────────────────────────────────────────────
        case actions.GET_INSUMOS_SUCCESS:
            return { ...state, insumos: action.payload };

        case actions.GET_MERCANCIAS_SUCCESS:
            return { ...state, mercancias: action.payload };

        case actions.CREATE_INSUMO_SUCCESS:
            return { ...state, insumos: [...state.insumos, action.payload] };

        case actions.EDIT_INSUMO_SUCCESS:
            return {
                ...state,
                insumos: state.insumos.map(i => i._id === action.payload._id ? action.payload : i),
                mercancias: state.mercancias.map(i => i._id === action.payload._id ? action.payload : i),
            };

        case actions.DELETE_INSUMO_SUCCESS:
            return {
                ...state,
                insumos:    state.insumos.filter(i => i._id !== action.payload),
                mercancias: state.mercancias.filter(i => i._id !== action.payload),
            };

        case actions.SET_CURRENT_INSUMO:
            return { ...state, currentInsumo: action.payload };

        case actions.CLEAR_CURRENT_INSUMO:
            return { ...state, currentInsumo: null };

        case actions.SET_CURRENT_PROCESO:
            return { ...state, currentProceso: action.payload };

        case actions.CLEAR_CURRENT_PROCESO:
            return { ...state, currentProceso: null };

        // ── Registro legado ───────────────────────────────────────────────────
        case actions.GET_REGISTRO_SUCCESS:
            return { ...state, inventario: action.payload };

        // ── Movimientos ───────────────────────────────────────────────────────
        case actions.GET_MOVIMIENTOS_REQUEST:
            return { ...state, loadingMovimientos: true };

        case actions.GET_MOVIMIENTOS_SUCCESS:
            return {
                ...state,
                loadingMovimientos:    false,
                movimientos:           action.payload.movimientos,
                paginacionMovimientos: action.payload.paginationInfo,
            };

        // ── Stock ─────────────────────────────────────────────────────────────
        case actions.GET_STOCK_REQUEST:
            return { ...state, loadingStock: true };

        case actions.GET_STOCK_SUCCESS:
            return {
                ...state,
                loadingStock:          false,
                stock:                 action.payload.stock,
                valorTotalInventario:  action.payload.valorTotalInventario,
            };

        // ── Alertas ───────────────────────────────────────────────────────────
        case actions.GET_ALERTAS_REQUEST:
            return { ...state, loadingAlertas: true };

        case actions.GET_ALERTAS_SUCCESS:
            return { ...state, loadingAlertas: false, alertas: action.payload };

        // ── Ajuste ────────────────────────────────────────────────────────────
        case actions.CREAR_AJUSTE_SUCCESS:
            return state; // el stock se recarga con getStock después del ajuste

        // ── Rotación ─────────────────────────────────────────────────────────
        case actions.GET_ROTACION_REQUEST:
            return { ...state, loadingRotacion: true };

        case actions.GET_ROTACION_SUCCESS:
            return { ...state, loadingRotacion: false, rotacion: action.payload };

        default:
            return state;
    }
}
